import Vue from 'vue'
import App from './calculator.vue'
import VueResource from 'vue-resource';

Vue.prototype.$getContent = function(key, defaultContent) {
    if(window.calcTranslations) {
      return window.calcTranslations[key];
    }
    return defaultContent;
};

Vue.use(VueResource);

if (window.siteAssetsConfig) {
  new Vue({
      el: '#calculator-app',
      render: h => h(App)
  });
}


// WEBPACK FOOTER //
// ./src/main.js